import React from 'react';
import Select, {AsyncCreatable as AsyncCreatableSelect, Async as AsyncSelect, Creatable as CreatableSelect}  from 'react-select';

import {translate} from 'iss/strings';
import BootstrapFormGroup from 'iss/widgets/bootstrap/FormGroup';

/** A combination of react-select and a bootstrap form group */
export function BootstrapSelect({id, creatable, ...props}) {
  const isAsync = props.async;
  const Component = creatable ?
    (isAsync ? AsyncCreatableSelect : CreatableSelect) :
    (isAsync ? AsyncSelect : Select);

  return <BootstrapFormGroup id={id} {...props}>
    <Component instanceId={id} placeholder={translate('common.selectPlaceholder')} aria-describedby={props.id+"-help-text"} {...props} inputProps={{id}}/>
  </BootstrapFormGroup>;
}

export default BootstrapSelect;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/Select.jsx